import axios from 'axios'

export default {
  // A caller-supplied cancelToken opts this request out of the global
  // cancel-on-route-change so each keystroke can cancel the previous one instead
  // (see plugins/axios.js). /api/search also degrades quietly on error there.
  search (q, cancelToken) {
    return axios.get('/api/search', { params: { q }, cancelToken })
  }
}
